import React from "react";
import TabBar, { TabBarProps } from "../../../../shared/components/TabBar"; // Adjust the import based on your project structure

interface MaterialTabNavigationProps {
  materialDetailTab: any;
  providerDetailTab: any;
}

const CreateMaterialTabNavigation = ({
  materialDetailTab,
  providerDetailTab,
}: MaterialTabNavigationProps) => {
  const tabs: TabBarProps[] = [
    {
      label: "Thông tin",
      labelEN: "info",
      content: materialDetailTab,
    },
    {
      label: "Nhà cung cấp",
      labelEN: "provider",
      content: providerDetailTab,
    },
  ];

  return <TabBar tabs={tabs} />;
};

export default CreateMaterialTabNavigation;
